import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "invoice_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const publicPdfUrl = (id) => `${API}/public/invoices/${id}/pdf`;
export const publicPayUrl = (id) => `${window.location.origin}/pay/${id}`;

export const formatCurrency = (amount, currency = "USD") => {
  const symbols = { USD: "$", EUR: "€", INR: "₹", GBP: "£" };
  const s = symbols[currency] || `${currency} `;
  return `${s}${Number(amount || 0).toFixed(2)}`;
};
